module.exports = __webpack_public_path__ + "static/image/history/pc/202602_2.ver2_0_2.jpg?ea14a327";